<div class="change-address single-card-column" [ngClass]="{'profile-checking-account': !isAcmic}">
  <div class="row text-center">
    <div class="col"> 
      <div class="header-icon full-icon">
        <ng-container *ngIf="isAcmic; else maState">
          <img src="./assets/img/images/icon-autopay-acmic.svg" alt="autopay cash icon" width="64" height="64" />
        </ng-container>
        <ng-template #maState>
          <img src="assets/img/images/icon-business-heritage.svg" alt="business heritage icon" />
        </ng-template>        
      </div>
      <div>
        <ng-container *ngIf="whereInTheProcess===':policyid/add-checking-account';else updateAccount">
          <h1 class="title-copy margin-bottom mb24">{{ 'ADD_CHECKING_SAVING_ACCOUNT' | translate }}</h1>
        </ng-container>
        <ng-template #updateAccount>
            <h1 class="title-copy margin-bottom mb24">{{ 'UPDATE_CHECKING_SAVING_ACCOUNT' | translate }}</h1>          
            <div class="sub-title-copy sus margin-bottom mb8">{{ 'CHECKING_SAVING_SUB_HEADING' | translate }}</div>
          </ng-template>
      </div>      
    </div>
  </div>  
  <app-checking-account-form [inputs]="checkingAccountForm"></app-checking-account-form>
</div>
